import { createApi } from '@reduxjs/toolkit/query/react';
import fetchBaseQuery from '../../../utils/fetchBaseQuery';
import servicesConfig from './services';
import endpointsBuilder from '../../../utils/endpointsBuilder';

export const userInfoApi = createApi({
  reducerPath: 'userInfoApi',
  baseQuery: fetchBaseQuery({}),
  endpoints: endpointsBuilder(servicesConfig),
});

export const {
  endpoints,
  useGetUserInfoQuery,
  useLazyGetUserInfoQuery,
} = userInfoApi;
